import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import PublishIcon from "@mui/icons-material/Publish";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { publishRedirects } from "../../api/marketing";
import { getErrorMessage } from "../../api/generic";

export default function RedirectsPublishSection({ onPublished }) {
  const [commitMessage, setCommitMessage] = useState("");
  const [error, setError] = useState("");
  const [lastPublish, setLastPublish] = useState(null);
  const [publishing, setPublishing] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handlePublishClick = () => {
    if (!commitMessage) {
      setError("Commit message is required.");
      return;
    }
    setError("");
    setConfirmOpen(true);
  };

  const publish = () => {
    setConfirmOpen(false);
    setPublishing(true);
    publishRedirects(
      commitMessage,
      (result) => {
        setPublishing(false);
        setCommitMessage("");
        setLastPublish(result);
        onPublished(result);
      },
      (error) => {
        setError(getErrorMessage(error));
        setPublishing(false);
      }
    );
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Generate redirects and push to the <strong>dataquestio/astro</strong>{" "}
        repository.
      </Typography>
      {lastPublish && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Redirects published (commit {lastPublish.commit_sha.slice(0, 7)})
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <TextField
        margin="dense"
        fullWidth
        multiline
        value={commitMessage}
        label="Commit message"
        onChange={(event) => setCommitMessage(event.target.value)}
      />
      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PublishIcon />}
          disabled={publishing}
          onClick={handlePublishClick}
        >
          Publish
        </Button>
      </Box>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color="warning" />
          Confirm publish
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will push directly to the <strong>dataquestio/astro</strong>{" "}
            repository. This action can&apos;t be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="warning"
            startIcon={<PublishIcon />}
            onClick={publish}
          >
            Publish
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
